/**
 * Copyright 2022-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const idSuffixBase = 10_000;

export class IdGenerator {
  private idSuffixOffset = 0;

  // getId returns an Id that generally increases with each call.
  // only exceptions are when idSuffix rotates back to 0 within the same millisecond
  // or when the clock goes back
  getId(): string {
    const idSuffix = idSuffixBase + this.idSuffixOffset;
    this.idSuffixOffset = (this.idSuffixOffset + 1) % idSuffixBase;
    const timestamp = Date.now();
    return `${timestamp}${idSuffix}`;
  }
}
